class CarMakes extends HTMLElement {
  constructor() {
    super();

    this.carMakesUrl = this.dataset.carMakesUrl;
    this.additionalContainer = this.querySelector(
      '[data-car-makes-additional]'
    );
  }
  
  connectedCallback() {
    if (!this.additionalContainer) return;
    this.init();
  }

  async init() {
    try {
      const data = await fetch('https://api.wiperz.co.uk/car/makes').then(r => r.json());

      this.renderAdditionalMakes(data);
    } catch (error) {
      console.error(error);
    }
  }

  renderAdditionalMakes(makes) {
    const featuredMakes = window.featuredMakes || [];

    const notFeaturedMakes = makes
      .filter((make) => {
        return !featuredMakes.includes(make.label);
      })

    this.additionalContainer.innerHTML = notFeaturedMakes
      .map((make) => {
        return `
            <li class="car-makes__list-item">
                <a
                    href="/pages/search-manufacturer?make=${make.label}"
                    class="car-makes__link"
                >
                    ${make.label}
                </a>
            </li>
        `;
      })
      .join('');
  }
}

if (!customElements.get('car-makes')) {
  customElements.define(
    'car-makes',
    CarMakes
  );
}